/**
 * @packageDocumentation
 * @module HackerAPI.User.Hacker
 */
import { __extends } from "tslib";
import Urls from "./urls/urls";
import Education from "./education/education";
import TravelInfo from "./travel-info/travel-info";
import Base from "../../base/base";
import Event from "../../event/event";
/**
 * A data container for things related to a hacker at an event
 * @struct
 * @extends { HackerAPI.Base }
 */
var Hacker = /** @class */ (function (_super) {
    __extends(Hacker, _super);
    /**
     * Creates a new Hacker instance
     * @constructor
     * @param
     */
    function Hacker(_a) {
        var _b = _a === void 0 ? {} : _a, skills = _b.skills, hackathons = _b.hackathons, urls = _b.urls, education = _b.education, school_email = _b.school_email, schoolEmail = _b.schoolEmail, travel = _b.travel;
        var _this = _super.call(this) || this;
        /**
         * The list of languages and technologies that the user is familiar with
         * @type { string[] }
         */
        _this.skills = skills || null;
        /**
         * The hackathons that the user has been to
         * @type { HackerAPI.Event[] } - Only `id`, `name`, `slug`, `startTime` and `endTime` are present
         */
        _this.hackathons = hackathons
            ? hackathons.map(function (h) { return new Event(h); })
            : null;
        /**
         * The links to all of the user's relevant accounts
         * @type { HackerAPI.User.Hacker.Urls }
         */
        _this.urls = urls ? new Urls(urls) : null;
        /**
         * Where the hacker is currently in school
         * @type { HackerAPI.User.Hacker.Education }
         */
        _this.education = education ? new Education(education) : null;
        /**
         * The hacker's school email
         * @type { string }
         */
        _this.schoolEmail = school_email || schoolEmail || null;
        /**
         * The hacker's travel info to getting to the event
         * @type { HackerAPI.User.Hacker.TravelInfo }
         */
        _this.travel = (travel && new TravelInfo(travel)) || null;
        return _this;
    }
    Object.defineProperty(Hacker, "Urls", {
        /**
         * @returns
         */
        get: function () {
            return Urls;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hacker, "Education", {
        /**
         * @returns
         */
        get: function () {
            return Education;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Hacker, "TravelInfo", {
        /**
         * @returns
         */
        get: function () {
            return TravelInfo;
        },
        enumerable: true,
        configurable: true
    });
    return Hacker;
}(Base));
export default Hacker;
//# sourceMappingURL=hacker.js.map